export default {
  id: 'Serie y número',
  invoiceId: 'Serie y número',
  title: 'Datos generales',
  format: 'Formato origen',
  created: 'Fecha de creación',
  issue: 'Fecha de emisión',
  incomeDate: 'Fecha devengo',
  help: 'Deberá cumplimentarse este dato si la fecha en que se haya efectuado la operación o se haya recibido el pago anticipado es distinto a la fecha de expedición de la factura.',
  equalToEmisionDate: 'Igual que la fecha de emisión',
  billingPeriod: 'Indicar periodo de facturación',
  billPeriod: {
    title: 'Periodo de facturación',
    start: 'Fecha de inicio',
    end: 'Fecha final'
  },
  billProcedure: {
    title: 'Factura de abono',
    serie: 'Serie - Número',
    reason: 'Razón de abono'
  },
  extra: {
    title: 'Información adicional',
    concept: 'Concepto',
    import: 'Adjuntar nuevo archivo'
  },
  addFile: {
    type: 'Tipo',
    description: 'Descripción*',
    date: 'Fecha de creación',
    fileTypeInfo: 'Para FACe, solo se admiten adjuntos del tipo PDF y HTML'
  },
  serieAndBillNumber: 'Introducir serie y número de factura manualmente',
  necessaryToStoreBill: 'Necesario para poder almacenar la factura respetando la serie y número externo indicados',
  serie: 'Serie',
  number: 'Número',
  sendInvoiceAsPayment: 'Si selecciona esta opción, la factura se enviará como un abono a favor del cliente destinatario de la factura.',
  emissorDiscount: 'Por lo tanto, se descontará el importe correspondiente, de la cuenta asociada al emisor.',
  contactData: 'Datos de contacto',
  addContactData: 'Añadir datos de contacto',
  onlyExpenses: 'Si desea que la factura sea de solo suplido marque el check',
  rectified: {
    title: 'Factura rectificada',
    reason: 'Razón rectificada',
    description: 'Descripción'
  },
  onlySupplied: 'La factura es de solo suplido',
  status: 'Estado',
  reason: 'Motivo de rechazo',
  faceb2bData: 'Datos de FACeB2B'
}
